import { render, staticRenderFns } from "./matching_foods.vue?vue&type=template&id=2648f01a&scoped=true&"
import script from "./matching_foods.vue?vue&type=script&lang=js&"
export * from "./matching_foods.vue?vue&type=script&lang=js&"
import style0 from "./matching_foods.vue?vue&type=style&index=0&id=2648f01a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648f01a",
  null
  
)

export default component.exports